import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Solana() {
  return (
    <PredictionPage
      title="Solana"
      content="This is the Solana AI Trading Predictions page."
      canonical="/cryptocurrencies/solana-ai-trading-predictions"
      categoryKey="nav.cryptocurrencies"
      categoryPath="/cryptocurrencies"
      symbol="SOLANA"
    />
  );
}

export default Solana;
